import {StrainSaveMeasurementDetailsModel} from "@app/strain/common/models/save-measurement-models/strain-save-measurement-details.model";
import {StrainSaveMeasurementGageMountingModel} from "@app/strain/common/models/save-measurement-models/strain-save-measurement-gage-mounting.model";
import {StrainSaveMeasurementInstructionImages} from "@app/strain/common/models/save-measurement-models/strain-save-measurement-instruction.images";
import {StrainSaveMeasurementGageChartModel} from "@app/strain/common/models/save-measurement-models/strain-save-measurement-gage-chart.model";

export class StrainSaveMeasurement {
    public registryEntryId: number;
    public measurementById: number;
    public measurementDate: Date;
    public details: StrainSaveMeasurementDetailsModel;
    public gageMounting: StrainSaveMeasurementGageMountingModel;
    public gageCharts: StrainSaveMeasurementGageChartModel[];
    public images: StrainSaveMeasurementInstructionImages[];

    constructor(measurement: any = {}) {
        this.measurementDate = measurement.measurementDate || null;
        this.registryEntryId = measurement.registryEntryId || null;
        this.measurementById = measurement.measurementById || null;
        this.details = measurement.details ? new StrainSaveMeasurementDetailsModel(measurement.details) : null;
        this.gageCharts = measurement.gageCharts ? measurement.gageCharts : [];
        this.gageMounting = measurement.gageMounting ? measurement.gageMounting : null;
        this.images = measurement.images ? measurement.images : [];
    }
}
